import type { EntregaItem } from '../types/database'

export type SituacaoDivergencia = 'conforme' | 'a_mais' | 'a_menos' | 'misto'

export const SITUACAO_DIVERGENCIA_LABELS: Record<SituacaoDivergencia, string> = {
  conforme: 'Conforme',
  a_mais: 'A mais',
  a_menos: 'A menos',
  misto: 'Misto',
}

export function situacaoEntrega(
  itens: Pick<EntregaItem, 'quantidade' | 'quantidade_planejada'>[] | undefined,
): SituacaoDivergencia {
  let hasMais = false
  let hasMenos = false
  for (const it of itens || []) {
    const q = Number(it.quantidade) || 0
    const p = Number(it.quantidade_planejada ?? it.quantidade) || 0
    if (q > p) hasMais = true
    if (q < p) hasMenos = true
  }
  if (hasMais && hasMenos) return 'misto'
  if (hasMais) return 'a_mais'
  if (hasMenos) return 'a_menos'
  return 'conforme'
}

export function badgeSituacaoDivergencia(s: SituacaoDivergencia) {
  if (s === 'conforme') return 'badge badge-ok'
  if (s === 'a_mais') return 'badge badge-atencao'
  return 'badge badge-critico'
}
